import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { fromEvent, Observable } from 'rxjs';
import { retryWhen, tap } from 'rxjs/operators';

@Injectable()
export class RetryRequest implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('sendMessageByChannel')) {
      return next.handle(request).pipe(
        retryWhen(() => {
          return fromEvent(window, 'online').pipe(
            tap(() => {
              console.error('[Online Again] Retry http request failed')
            })
          );
        })
      );
    }
    return next.handle(request);
  }
}

